import {api, apiInternal, ApiListResponse, commonApiWrapper} from './common-api';
import {ICreateEvent, IEventV2} from '@/app/dashboard/models/Event';


export const getRecentEventList = async () => commonApiWrapper<ApiListResponse<IEventV2>>(apiInternal.get('event/recent', {params: {limit: 4}}));
export const getOrganizerEventList = async () => commonApiWrapper<ApiListResponse<IEventV2>>(api.get('event/organizer', {params: {limit: 4}}));
export const getSingleEventList = async (id: string,  previewToken?: string) => commonApiWrapper<IEventV2>(api.get(`event/single/${id}`, {headers:{
        'X-Preview-Token': previewToken
    }}));
export const getEventForList = async (body: any = {}, offset: number = 0, limit: number = 9) => commonApiWrapper<ApiListResponse<IEventV2>>(api.post('event/query', body, {
    params: {
        offset,
        limit
    }
}));


export const createEventAPI = async (event: ICreateEvent, image: File) => {
    const formData = new FormData();
    Object.entries(event).forEach(([key, value]) => {
        formData.append(key, value);
    })
    formData.append('image', image);


    return commonApiWrapper<IEventV2>(api.post('event/create', formData, {
        headers: {'Content-Type': 'multipart/form-data'}
    }));
}